import Vue from 'vue'
import App from './App.vue'
import less from 'less'
import router from '@/router/index'
import store from './store'
Vue.use(less)
import VScaleScreen from 'v-scale-screen'
Vue.use(VScaleScreen)
import '@/assets/fonts/iconfont/iconfont.css'
import '@/assets/fonts/selfIconfont.css'
import * as echarts from 'echarts'
import '@/utils/rem'
import axios from 'axios'
Vue.prototype.$axios = axios
//axios.defaults.baseURL = 'http://4m372120p6.zicp.fun'
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
//axios.defaults.baseURL = 'http://localhost:8081'
Vue.prototype.$echarts = echarts
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//import '@/assets/fontFamily/zixiaohunliliangcuheiti_font.css'
//import '@/assets/fontFamily/fonts.css'
Vue.use(ElementUI)
Vue.config.productionTip = false

import 'amfe-flexible'

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount('#app')
